import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const liberacaoAutomaticaRepository = createRepository({
  path: 'liberacao-automatica',
  restApi,
  queryTransform: {
    descricao: query.ilikeWithoutSplit('descricao'),
    ...paginate
  }
})

liberacaoAutomaticaRepository.liberarMotorista = (cpfMotorista, placa) => {
  return restApi.post(`liberacao-automatica`, {
    cpf: cpfMotorista,
    placa
  })
}

export default liberacaoAutomaticaRepository
